/**
 * ✏️ PASTE YOUR FIREBASE WEB CONFIG HERE.
 *
 * Firebase Console → Project settings → General → Your apps → Web app →
 * "SDK setup and configuration" → Config. Copy the object over the
 * placeholders below.
 *
 * Until real values are pasted in, the app runs in DEMO MODE with sample
 * guests and photos so you can explore every feature locally.
 */
export const firebaseConfig = {
  apiKey: "AIzaSyCltgC90ZQo7-ZGFWwpksnLh9ZB0edUhBo",
  authDomain: "sara-gregor-wedding.firebaseapp.com",
  projectId: "sara-gregor-wedding",
  storageBucket: "sara-gregor-wedding.firebasestorage.app",
  messagingSenderId: "553178860679",
  appId: "1:553178860679:web:567f18ef91c212029f3c22",
};

export const isFirebaseConfigured = !firebaseConfig.apiKey.startsWith("PASTE");
